import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
//import banner from '../../images/banner_bigScreen2.PNG'
import knapper from '../../../images/Knapper_logo_full.png'
import './Banner.css'

const Banner = () => {
	return (
		<a
			className='bannerLink'
			href='https://knapperusa.com/'
			target='_blank'
			rel='noopener noreferrer'
		>
			<img src={knapper} className='banner' alt='Knapper USA' />
		</a>
	)
}

export default Banner
